export function convertDecimalToCurrency(currency: number): number {
  const cents = currency * 100;

  return Math.round(cents);
}
